import React, { useState, useEffect } from 'react';
import { AxiosInstance } from '../../../common/Loader/axios.config';
import Select from 'react-select';
import Swal from 'sweetalert2';

const CreateNewModal = ({ isOpen, onClose }) => {
    const [formData, setFormData] = useState({
        title: '',
        description: '',
        price: '',
        category: '',
        thumbnail: null,
        tags: '',
        project_name: '',
        provider: '',
        age_restriction: '',
        resolution: '',
        type: '',
    });

    const [providers, setProviders] = useState([]);

    const [loading, setLoading] = useState(false);


    useEffect(() => {
        AxiosInstance.get("/content-providers")
            .then((response) => {
                const allProviders = response.data;

                const sortedProviders = allProviders.sort((a, b) => {
                    return (
                        new Date(b.created_at).getTime() - new Date(a.created_at).getTime()
                    );
                });

                setProviders(sortedProviders)
            })
            .catch((error) => {
            });
    }, []);

    const providerOptions = providers.map((provider) => ({
        value: provider.id,
        label: provider.name,
    }));

    const [selectedProvider, setSelectedProvider] = useState(null);

    const handleProviderChange = (option) => {
        setSelectedProvider(option);
        setFormData({ ...formData, provider: option.value });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleFileChange = (e) => {
        setFormData({ ...formData, thumbnail: e.target.files[0] });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        const formDataToSend = new FormData();
        console.log('Form Data before submission:', formData); // Log the form data

        // Append each field from formData to formDataToSend
        Object.keys(formData).forEach(key => {
            if (formData[key] !== undefined && formData[key] !== null) {
                console.log(`Appending ${key}:`, formData[key]); // Log each key-value pair
                formDataToSend.append(key, formData[key]);
            } else {
                console.warn(`Skipping ${key} because it is undefined or null`); // Log a warning if the value is null or undefined
            }
        });

        setLoading(true); // Set loading state

        // Send the form data to the server
        AxiosInstance.post('/new-content', formDataToSend)
            .then((response) => {
                console.log('Response:', response); // Log the full response
                if (response.data.status === "successful") {
                    console.log('Content created successfully:', response.data.message);
                    Swal.fire({
                        icon: 'success',
                        title: 'Content Created successfully!',
                        showConfirmButton: false,
                        timer: 2000,
                      });
                    onClose(); // Close the modal after successful submission
                } else {
                    console.error('Submission failed:', response.data.message);
                    Swal.fire({
                        icon: 'error',
                        title: 'Failed to create Content',
                        text: 'An error occurred while creating Content.',
                      });
                    setLoading(false); // Stop loading
                    // Handle unsuccessful submission (e.g., show an error message)
                }
            })
            .catch((error) => {
                console.error('Error creating content:', error);
                if (error.response) {
                    console.error('Error response:', error.response.data); // Log error response
                } else {
                    console.error('Error message:', error.message); // Log error message
                }
                Swal.fire({
                    icon: 'error',
                    title: 'Failed to Create Content',
                    text: 'An error occurred while creating Content.',
                  });
                setLoading(false); // Stop loading
                // Handle error messages here if needed
            });
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75">
            <div className="bg-brand-background rounded-lg p-6 w-1/2">
                <h2 className="text-lg font-semibold mb-4 text-white">Create New Series</h2>
                <form onSubmit={handleSubmit} className="grid grid-cols-2 gap-4">
                    <div>
                        <label className="block mb-2 text-white">Title</label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter title"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter description"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Price</label>
                        <input
                            type="number"
                            name="price"
                            value={formData.price}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter price"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Category</label>
                        <select
                            name="category"
                            value={formData.category}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            required
                        >
                            <option value="">Select Category</option>
                            <option value="shorts">Shorts</option>
                            <option value="series">Series</option>
                            <option value="event">Event</option>
                            <option value="vod">Video</option>
                        </select>
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Thumbnail</label>
                        <input
                            type="file"
                            accept="image/*"
                            name="thumbnail"
                            onChange={handleFileChange}
                            onChange={handleFileChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Tags</label>
                        <input
                            type="text"
                            name="tags"
                            value={formData.tags}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter tags"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Project Name</label>
                        <input
                            type="text"
                            name="project_name"
                            value={formData.project_name}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter project name"
                            required
                        />
                    </div>
                    <div className='text-black'>
                        <label className="block mb-2 text-white">Provider</label>
                        <Select
                            value={selectedProvider}
                            onChange={handleProviderChange}
                            options={providerOptions}
                            placeholder="Select Provider..."
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Age Restriction</label>
                        <input
                            type="text"
                            name="age_restriction"
                            value={formData.age_restriction}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter age restriction"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Resolution</label>
                        <input
                            type="text"
                            name="resolution"
                            value={formData.resolution}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            placeholder="Enter resolution"
                            required
                        />
                    </div>
                    <div>
                        <label className="block mb-2 text-white">Type</label>
                        <select
                            name="type"
                            value={formData.type}
                            onChange={handleChange}
                            className="border border-brand-stroke-color rounded w-full p-2 bg-transparent text-white placeholder-white"
                            required
                        >
                            <option value="">Select Type</option>
                            <option value="shorts">Shorts</option>
                            <option value="series">Series</option>
                        </select>
                    </div>
                    <div className="col-span-2">
                        <button type="submit" className="bg-primary text-white py-2 px-4 rounded">
                            {loading ? 'Creating...' : 'Create'}
                        </button>
                    </div>
                </form>
                <button onClick={onClose} className="mt-4 bg-red-500 text-white py-2 px-4 rounded">Close</button>
            </div>
        </div>
    );
};

export default CreateNewModal;